import React from 'react'

const MainIntervention = () => {
  return (
    <div>Page not found</div>
  )
}

export default MainIntervention